import { Editor, Node as SlateNode, Range as SlateRange, Transforms } from 'slate';

import { SLATE_TEXT_FORMATS } from 'src/lib/slate';

import { LIST_TYPES } from '../const';

export const withNewLine = (editor) => {
  const { insertBreak } = editor;

  editor.insertBreak = () => {
    if (SlateRange.isCollapsed(editor.selection)) {
      const textNode = SlateNode.get(editor, editor.selection && editor.selection.anchor.path);
      const parentPath = editor.selection && editor.selection.anchor.path.slice(0, -1);
      const parentNode = SlateNode.get(editor, parentPath);
      if (/^\n*$/.test(textNode.text) && SLATE_TEXT_FORMATS.LIST_ITEM === parentNode.type) {
        Editor.withoutNormalizing(editor, () => {
          const listPath = parentPath.slice(0, -1);
          const listNode = SlateNode.get(editor, listPath);
          let newPath;
          if (LIST_TYPES.includes(listNode.type) && listNode.children.length === 1) {
            Transforms.removeNodes(editor, { at: listPath });
            newPath = listPath;
          } else {
            Transforms.removeNodes(editor, { at: parentPath });
            newPath = [...parentPath.slice(0, -2), parentPath[parentPath.length - 2] + 1];
          }
          Transforms.insertNodes(
            editor,
            { type: SLATE_TEXT_FORMATS.PARAGRAPH, children: [{ text: '' }] },
            { at: newPath }
          );
          Transforms.select(editor, {
            anchor: { path: [...newPath, 0], offset: 0 },
            focus: { path: [...newPath, 0], offset: 0 },
          });
        });
        return;
      }
    }

    // fall back to default behavior
    insertBreak();
  };

  return editor;
};
